import { Wifi, WifiOff, RefreshCw, Cloud } from 'lucide-react';

const OfflineIndicator = ({ isOnline, isSyncing, pendingCount, onSync }) => {
    if (isOnline && pendingCount === 0 && !isSyncing) {
        return null;
    }

    return (
        <div className="flex items-center gap-2">
            {/* Pending sync badge */}
            {pendingCount > 0 && (
                <button
                    onClick={onSync}
                    disabled={!isOnline || isSyncing}
                    className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-all ${
                        isOnline 
                            ? 'bg-amber-100 text-amber-700 hover:bg-amber-200' 
                            : 'bg-slate-100 text-slate-600'
                    }`}
                    title={isOnline ? 'Click to sync' : 'Will sync when online'}
                >
                    {isSyncing ? (
                        <RefreshCw className="h-3 w-3 animate-spin" />
                    ) : (
                        <Cloud className="h-3 w-3" />
                    )}
                    <span>{pendingCount} pending</span>
                </button>
            )}

            {/* Offline indicator */}
            {!isOnline && (
                <div className="flex items-center gap-1.5 px-2.5 py-1 bg-red-100 text-red-700 rounded-full text-xs font-medium">
                    <WifiOff className="h-3 w-3" />
                    <span>Offline</span>
                </div>
            )}

            {/* Syncing indicator */}
            {isSyncing && pendingCount === 0 && (
                <div className="flex items-center gap-1.5 px-2.5 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">
                    <RefreshCw className="h-3 w-3 animate-spin" />
                    <span>Syncing...</span>
                </div>
            )}
        </div>
    );
};

export default OfflineIndicator;
